/**
 * Standardized error for user input validation
 * UI can reliably render err.message and optionally highlight field
 */

export class UserInputError extends Error {
  code: string;
  field?: string;

  constructor(code: string, message: string, field?: string) {
    super(message);
    this.name = "UserInputError";
    this.code = code;
    this.field = field;
  }
}
